import http from './plugin/ajax'

// 验证码
export const reqAuthCode = (data) => http.get('/auth/vercode', data)
// 登录
export const reqLogin = (data) => http.post('/auth/login', data)
